import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgContactOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 23 23"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#3F4347"
      fillRule="evenodd"
      d="M3.967 2.62c-.609 0-1.347.626-1.347 1.609v11.008c0 1.018.724 1.608 1.347 1.608h2.57v2.484l3.18-2.484h8.936c.655 0 1.347-.575 1.347-1.608V4.229c0-.998-.706-1.609-1.347-1.609zM0 4.229C0 2.036 1.686 0 3.967 0h14.686c2.342 0 3.967 2.052 3.967 4.229v11.008c0 2.244-1.64 4.228-3.967 4.228h-8.034l-3.522 2.75a1.935 1.935 0 0 1-2.22.105 2.06 2.06 0 0 1-.96-1.848v-1.007C1.673 19.435 0 17.479 0 15.237z"
      clipRule="evenodd"
    />
    <path
      fill="#3F4347"
      d="M6.862 7.699c0-.46.373-.834.833-.834h7.223a.833.833 0 1 1 0 1.667H7.695a.833.833 0 0 1-.833-.833M6.862 11.033c0-.46.373-.834.833-.834h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.833-.833"
    />
  </svg>
);
export default SvgContactOutlined;
